import React, { useState, useRef, useEffect } from 'react';
import './singleplay.css';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import DownloadIcon from '@mui/icons-material/Download';
import StarIcon from '@mui/icons-material/Star';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { baseURL } from '../../redux/axios/axios';
import CircularProgress from '@mui/material/CircularProgress';
import uploadimg from '../../assets/icons/uploadblog.png'

import axios from 'axios';
import { toast } from 'react-toastify';
import AddFvrtMusicModal from '../Music/AddFvrtMusicModal';

const SinglePlayer = ({audiodata,detailsPage,detailpageStyle,sendToParent, setmusicPlayToggle, musicPlayToggle}) => {

  let login = JSON.parse(localStorage.getItem('user'));
    const [playToggle, setPlayToggle] = useState(false);
  const [currentAudio, setcurrentAudio] = useState()
  const [previousId, setPreviousId] = useState()
  const [audioStates, setAudioStates] = useState([]);
  const [getData, setgetData] = useState()
  const [downloadOpen, setdownloadOpen] = useState();
  const [musicData,setMusicData] = useState([])
  const [openModalFvrt, setopenModalFvrt] = useState(false)
  const [audioPlayStatus, setaudioPlayStatus] = useState(false)

  const audioRefs = useRef( audiodata?.map(() => React.createRef()));

  
 
  const togglePlay = (index) => {
  
    const audioRef = audioRefs.current[index];
   

    if (audioRef) {

      if (playToggle )
       {
         
        audioRef.current.pause();
        setPlayToggle(!playToggle); 
        setmusicPlayToggle((prev)=>({
          ...prev,
          id:'',
          status:false
        }))
     
      } 
      else 
      { 
        

        audioRef.current.play();
       setPlayToggle(!playToggle); 
       setmusicPlayToggle((prev)=>({
        ...prev,
        id:'single',
        status:true
      }))
     
      }
      
      // const isPlaying = !audioRef.current.paused;
  setcurrentAudio(index)
 
      // setaudioPlayStatus(isPlaying)
     
    
      
    }
  };



 useEffect(()=>{

if(musicPlayToggle.id==='multiple' && musicPlayToggle.status===true){
  audioRefs.current[currentAudio]?.current.pause();
  setPlayToggle(false)
}
 },[musicPlayToggle])


 

  // Function to update the progress for a specific audio file
  const updateProgressBar = (index) => {
    const audioRef = audioRefs?.current[index]?.current;

    if (audioRef) {
      const currentTime = audioRef?.currentTime;
      const newProgress = (currentTime / audioRef.duration) * 100;

      setAudioStates((prevAudioStates) => {
        const updatedStates = [...prevAudioStates];
        updatedStates[index] = { ...updatedStates[index], progress: newProgress };
        return updatedStates;
      });
    }
  };

  // Function to handle metadata load for a specific audio file
  const handleMetadataLoad = (index) => {
    audiodata?.forEach((item, i) => {
      const audioRef = audioRefs?.current[i]?.current;
  
      if (audioRef) {
       
       
        sendToParent(audioRef.duration)
        setAudioStates((prevAudioStates) => {
          const updatedStates = [...prevAudioStates];
          updatedStates[i] = { ...updatedStates[i], duration: audioRef.duration };
          return updatedStates;
        });
      } else {
        console.log(`Audio element at index ${i} is not loaded yet.`);
      }
    });
  
    // Rest of your code...
  };
  

  // Function to handle progress bar click for a specific audio file
  const handleProgressBarClick = (index, event) => {
    const audioRef = audioRefs?.current[index]?.current;

    if (audioRef) {
      const progressBar = event.currentTarget;
      const clickPosition = event.clientX - progressBar.getBoundingClientRect().left;
      const percentage = (clickPosition / progressBar.offsetWidth) * 100;
      const newTime = (percentage / 100) * audioRef.duration;
      audioRef.currentTime = newTime;

      setAudioStates((prevAudioStates) => {
        const updatedStates = [...prevAudioStates];
        updatedStates[index] = { ...updatedStates[index], progress: percentage };
        return updatedStates;
      });
    }
  };

const formatTime = (time) => {
  if (!isNaN(time)) {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  } else {
    return '0:00';
  }
};



useEffect(() => {
  if (audiodata?.length > 0) {

     const handleMetadataLoadHandler = () => handleMetadataLoad(currentAudio);
  const updateProgressBarHandler = () => updateProgressBar(currentAudio);

  audiodata?.forEach((_, i) => {
    const audioRef = audioRefs?.current[i]?.current;
    if (audioRef) {
      audioRef.addEventListener('loadedmetadata', handleMetadataLoadHandler);
      audioRef.addEventListener('timeupdate', updateProgressBarHandler);
    }
  });

  return () => {
    audiodata?.forEach((_, i) => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      const audioRef = audioRefs.current[i]?.current;
      if (audioRef) {
        audioRef.removeEventListener('loadedmetadata', handleMetadataLoadHandler);
        audioRef.removeEventListener('timeupdate', updateProgressBarHandler);
      }
    });
  };
  }
 
}, [currentAudio, playToggle,audiodata]);

  



const [windowWidth, setWindowWidth] = useState(window.innerWidth);

useEffect(() => {
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  window.addEventListener('resize', handleResize);

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

const download = async (soundId,soundTitle) => {
  try {
    setdownloadOpen(soundId);


    const response =  await axios.post(`${baseURL}/sound/sounds/download`, {
      soundIds: [soundId],
      }, {
        responseType: 'blob',
       
      });
 
      const blob = new Blob([response.data]);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${soundTitle}.zip`; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
  } catch (error) {
    console.error('Failed to download sounds:', error);
  } finally {
    setdownloadOpen();
  }
};

const openFvrt = (item) =>{
  if (login) {
    setMusicData(item);
    setopenModalFvrt(!openModalFvrt);
  } else {
    toast.error('Please login to store music in your collection.',{autoClose:2000}); 
  }
 } 

  return (
    <>


<AddFvrtMusicModal
        closeModal={openFvrt}
        ModalIsOpen={openModalFvrt}
        selectedCheckboxes={musicData}
      />
    {audiodata && audiodata?.map((item,i)=>{



  const descriptionWords = item?.title.split(' ');
  const title6 = descriptionWords?.slice(0,2).join(' ');
  const title3 = descriptionWords?.slice(0,1).join(' ');
     

      return(
       
        <div className={`single-container shadow my-1 p-0 ${detailpageStyle===true? "detail-style":''}`} key={i} >
        <div className="single-inner-content" 
        // onClick={()=>detailsPage(item)}
        >
          <div className="single-player-image"  style={{cursor:"pointer"}} onClick={detailpageStyle===true? '': ()=>detailsPage(item)}>
            <img src={item?.image?.length>0 ? item.image[0]:uploadimg} alt="" style={{ width: '50px',height:'50px' }} />
          </div>

          <div className="single-play-button">
           
            {!playToggle  ? 
            (
                  <PlayArrowIcon
                    style={{ color: 'white', fontSize: '30px' }}
                    onClick={() => togglePlay(i)}
                  />
                ) 
                :
               
                 
                  
                  <PauseIcon
                    style={{ color: 'white', fontSize: '30px' }}
                    onClick={() => togglePlay(i)}
                  />
                }
          </div>

          <div className={`single-artist-title ${windowWidth <= 600 ? 'ellipsis' : ''}`}>
        <div>
          <p className="m-0 text-white" style={{ fontSize: '14px' }}>
            <span className="title-text">{
            windowWidth <= 600 ?  
      
             title6:  windowWidth <= 400 ?  
            title3: item?.title}</span>
            <span style={{ color: 'yellow', display:`${  windowWidth <= 600 ? 'none':''}` }}>{' '}NEW</span>
          </p>
          <small className="" style={{ color: '#E6E2DF' }}>{item?.owner_name}</small>
        </div>
      </div>

          <div className="single-music-type">
            <div>
              <p className="m-0" style={{ fontSize: '14px', color: 'white' }}>
                Music Type
              </p>
            </div>
          </div>

        
              <div className="single-player-timer">
                <p className="m-0" style={{ fontSize: '14px', color: 'white' }}>
                  {formatTime(audioRefs.current[i]?.current?.currentTime)} / {formatTime(audioStates[i]?.duration)}
                </p>
              </div>
           
            <div className='single-big-bar'>
              <div className="single-progress-bar" onClick={(event) => handleProgressBarClick(i, event)}>
                
                <div
                  className="single-progress-indicator"
                  style={{ width: `${audioStates[i]?.progress}%` }}
                />
              </div>
            </div>

         

          <audio ref={audioRefs.current[i]} src={item?.file?.length>0? item.file[0]:''} />
         
        </div>





        
        <div className=' d-flex justify-content-center align-items-center single-small-bar'>
              <div className="small-single-progress-bar" onClick={(event) => handleProgressBarClick(i, event)}>
                
                <div
                  className="small-single-progress-indicator"
                  style={{ width: `${audioStates[i]?.progress}%` }}
                />
              </div>
            </div>
      </div>
        
      )
    })}
      





     
    </>
  );
};

export default SinglePlayer;
